import { render, staticRenderFns } from "./ElementaryExam.vue?vue&type=template&id=33140324&"
import script from "./ElementaryExam.vue?vue&type=script&lang=js&"
export * from "./ElementaryExam.vue?vue&type=script&lang=js&"
import style0 from "./ElementaryExam.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports